import { render, staticRenderFns } from "./apply_suggestion.vue?vue&type=template&id=7df40b63"
import script from "./apply_suggestion.vue?vue&type=script&lang=js"
export * from "./apply_suggestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports